<template>
  <div class="card" v-loading="loading">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-6">
          <div>
            <p class="text-deepBlue font-semibold">Industry Sectors</p>
          </div>
          <hr class="mb-4 mt-2" />
          <div>
            <table class="w-full">
              <thead>
                <tr>
                  <th class="w-4/5">Sectors</th>
                  <th class="w-1/5">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(sector, index) in industrySectors" :key="index">
                  <td>{{ sector }}</td>
                  <td class="flex cursor-pointer">
                    <span @click="editSector(index)"
                      ><svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.125 16.9688H0.875C0.460156 16.9688 0.125 17.3039 0.125 17.7188V18.5625C0.125 18.6656 0.209375 18.75 0.3125 18.75H18.6875C18.7906 18.75 18.875 18.6656 18.875 18.5625V17.7188C18.875 17.3039 18.5398 16.9688 18.125 16.9688ZM3.53984 15C3.58672 15 3.63359 14.9953 3.68047 14.9883L7.62266 14.2969C7.66953 14.2875 7.71406 14.2664 7.74688 14.2313L17.682 4.29609C17.7038 4.27441 17.721 4.24866 17.7328 4.2203C17.7445 4.19195 17.7506 4.16156 17.7506 4.13086C17.7506 4.10016 17.7445 4.06977 17.7328 4.04142C17.721 4.01306 17.7038 3.98731 17.682 3.96563L13.7867 0.0679688C13.7422 0.0234375 13.6836 0 13.6203 0C13.557 0 13.4984 0.0234375 13.4539 0.0679688L3.51875 10.0031C3.48359 10.0383 3.4625 10.0805 3.45312 10.1273L2.76172 14.0695C2.73892 14.1951 2.74707 14.3243 2.78545 14.446C2.82384 14.5677 2.89132 14.6782 2.98203 14.768C3.13672 14.918 3.33125 15 3.53984 15Z"
                          fill="#383F51"
                        />
                      </svg>
                    </span>
                    <span class="pl-2" @click="deleteSector(index)">
                      <svg
                        width="12"
                        height="16"
                        viewBox="0 0 12 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.857143 14.0004C0.857143 14.9433 1.62857 15.7147 2.57143 15.7147H9.42857C10.3714 15.7147 11.1429 14.9433 11.1429 14.0004V3.7147H0.857143V14.0004ZM2.57143 5.42899H9.42857V14.0004H2.57143V5.42899ZM9 1.14328L8.14286 0.286133H3.85714L3 1.14328H0V2.85756H12V1.14328H9Z"
                          fill="#A5ADB7"
                        />
                      </svg>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mt-12">
            <!-- <primary-button buttonText="Add" /> -->
            <base-button
              text="Add"
              width="w-24"
              background="bg-darkBlue"
              color="text-white"
              @click="isIndustrySectorModal = true"
            />
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-6">
          <div>
            <p class="text-deepBlue font-semibold">Products & Services</p>
          </div>
          <hr class="mb-4 mt-2" />
          <div>
            <table class="w-full">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Category</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, index) in products" :key="index">
                  <td>{{ product.name }}</td>
                  <td>{{ product.category }}</td>
                  <td class="flex cursor-pointer">
                    <span @click="editProduct(index)"
                      ><svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.125 16.9688H0.875C0.460156 16.9688 0.125 17.3039 0.125 17.7188V18.5625C0.125 18.6656 0.209375 18.75 0.3125 18.75H18.6875C18.7906 18.75 18.875 18.6656 18.875 18.5625V17.7188C18.875 17.3039 18.5398 16.9688 18.125 16.9688ZM3.53984 15C3.58672 15 3.63359 14.9953 3.68047 14.9883L7.62266 14.2969C7.66953 14.2875 7.71406 14.2664 7.74688 14.2313L17.682 4.29609C17.7038 4.27441 17.721 4.24866 17.7328 4.2203C17.7445 4.19195 17.7506 4.16156 17.7506 4.13086C17.7506 4.10016 17.7445 4.06977 17.7328 4.04142C17.721 4.01306 17.7038 3.98731 17.682 3.96563L13.7867 0.0679688C13.7422 0.0234375 13.6836 0 13.6203 0C13.557 0 13.4984 0.0234375 13.4539 0.0679688L3.51875 10.0031C3.48359 10.0383 3.4625 10.0805 3.45312 10.1273L2.76172 14.0695C2.73892 14.1951 2.74707 14.3243 2.78545 14.446C2.82384 14.5677 2.89132 14.6782 2.98203 14.768C3.13672 14.918 3.33125 15 3.53984 15Z"
                          fill="#383F51"
                        />
                      </svg>
                    </span>
                    <span class="pl-2" @click="deleteProduct(index)">
                      <svg
                        width="12"
                        height="16"
                        viewBox="0 0 12 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.857143 14.0004C0.857143 14.9433 1.62857 15.7147 2.57143 15.7147H9.42857C10.3714 15.7147 11.1429 14.9433 11.1429 14.0004V3.7147H0.857143V14.0004ZM2.57143 5.42899H9.42857V14.0004H2.57143V5.42899ZM9 1.14328L8.14286 0.286133H3.85714L3 1.14328H0V2.85756H12V1.14328H9Z"
                          fill="#A5ADB7"
                        />
                      </svg>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-12">
            <base-button
              text="Add"
              width="w-24"
              background="bg-darkBlue"
              color="text-white"
              @click="isProductModal = true"
            />
          </div>
        </div>
      </div>
    </div>

    <industry-sector-modal
      :show-modal="isIndustrySectorModal"
      @close-modal="(selectedIndustrySector = null), (isIndustrySectorModal = false)"
      @created="getIndustryAndProductSettings"
      :industrySectors="industrySectors"
      :products="products"
      :selectedIndustrySector="selectedIndustrySector"
    />

    <product-modal
      :show-modal="isProductModal"
      @close-modal="(selectedProduct = null), (isProductModal = false)"
      @created="getIndustryAndProductSettings"
      :industrySectors="industrySectors"
      :products="products"
      :selectedProduct="selectedProduct"
    />

    <delete-modal
      :show-modal="isDeleteModal"
      @close-modal="isDeleteModal = false"
      :itemToDelete="selectedItem"
      :deletingItem="loading"
      @delete-item="deleteItem"
    />
  </div>
</template>

<script>
import IndustrySectorModal from "../Modals/IndustrySectorForm";
import ProductModal from "../Modals/ProductForm";
import DeleteModal from "@/components/UI/Modal/DeleteModal";

export default {
  name: "industries-and-products",
  components: {
    IndustrySectorModal,
    ProductModal,
    DeleteModal,
  },
  data() {
    return {
      industrySectors: [],
      products: [],
      isIndustrySectorModal: false,
      isProductModal: false,
      selectedIndustrySector: null,
      isDeleteModal: false,
      selectedIndex: null,
      selectedItem: "",
      loading: false,
      selectedProduct: null,
      selectedIndustrySectorIndex: null,
      selectedProductIndex: null,
    };
  },
  mounted() {
    this.getIndustryAndProductSettings();
  },
  methods: {
    async getIndustryAndProductSettings() {
      this.loading = true;
      try {
        const response = await this.$_getIndustryAndProductSettings();
        this.logResponse(response);
        this.industrySectors = response.data.message.setting.industrySector;
        this.products = response.data.message.setting.products;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async updateSettings(type, value) {
      this.loading = true;
      let payload = {};
      if (type == "products") {
        payload = {
          payload: {
            setting: {
              industrySector: [...this.industrySectors],
              products: [...value],
            },
          },
        };
      } else {
        payload = {
          payload: {
            setting: {
              industrySector: [...value],
              products: [...this.products],
            },
          },
        };
      }

      try {
        const response = await this.$_updateIndustryAndProductSettings(payload);
        this.logResponse(response);
        this.generateToast("Success!", "success");
        this.getIndustryAndProductSettings();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    editSector(index) {
      this.selectedIndustrySector = this.industrySectors[index];
      this.isIndustrySectorModal = true;
    },
    deleteItem() {
      if (this.selectedProductIndex != null) {
        let updatedProducts = [...this.products];
        updatedProducts.splice(this.selectedProductIndex, 1);
        this.updateSettings("products", updatedProducts);
      } else {
        let updatedIndustrySectors = [...this.industrySectors];
        updatedIndustrySectors.splice(this.selectedIndustrySectorIndex, 1);
        this.updateSettings("sector", updatedIndustrySectors);
      }
      this.isDeleteModal = false;
    },
    deleteSector(index) {
      this.selectedIndustrySectorIndex = index;
      this.isDeleteModal = true;
    },
    editProduct(index) {
      this.selectedProduct = this.products[index];
      this.isProductModal = true;
    },
    deleteProduct(index) {
      this.selectedProductIndex = index;
      this.isDeleteModal = true;
    },
  },
};
</script>

<style scoped>
tr:nth-child(odd) {
  background-color: #f6f9fc;
}
thead tr {
  background: #ffffff !important;
}
td,
th {
  padding: 1rem 0.5rem;
  font-size: 1rem;
}
.address-options {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #dae8f6;
  border-radius: 5px;
}
.label {
  font-weight: 600;
  font-size: 0.9rem;
  padding-left: 0.5rem;
}
</style>
